export default "__VITE_ASSET__ClU1XRpy__"